module.exports = __webpack_public_path__ + "img/employees.5c90948c.svg";